import { render, staticRenderFns } from "./EncounterSocialHistory.vue?vue&type=template&id=268ee143&"
import script from "./EncounterSocialHistory.vue?vue&type=script&lang=js&"
export * from "./EncounterSocialHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports